module.exports = __webpack_public_path__ + "static/media/400245_02.41a17f84.png";